import { withStyles } from '@material-ui/core'
import React from 'react'
import { EVENT_STATUSES } from 'components/Tables/Events'
import Stage from './Stage'

export const STAGES_COLORS = {
  SUCCESS: '#01ABFB',
  FAILED: '#FF4D4F',
  PROGRESS: '#00000040'
}

const Stepper = ({ classes, setBackgroundColor, event }) => {
  const currentStageNumber = React.useMemo(() => {
    for (let key in EVENT_STATUSES) {
      if (key === event.status) {
        return EVENT_STATUSES[key]
      }
    }
    return 1
  }, [event.status, event.staging, event.id])

  const stages = event.staging

  return (
    <div className={classes.wrapper}>
      {Object.keys(stages).map((key) => {
        if (
          Number(key) === currentStageNumber &&
          stages[key].success === false
        ) {
          setBackgroundColor('#fff1f0')
        }
        if (key >= currentStageNumber) {
          return (
            <Stage
              stage={key}
              isSuccess={stages[key].success}
              stageStatus={'progress'}
              key={key}
            />
          )
        }
        return (
          <Stage
            stage={key}
            isSuccess={stages[key].success}
            stageStatus={'finished'}
            key={key}
          />
        )
      })}
    </div>
  )
}

const styles = () => ({
  wrapper: {
    textAlign: 'center',
    lineHeight: 0,
    fontSize: 0
  }
})

export default withStyles(styles)(Stepper)
